import React from 'react';
import { CircularProgress, Grid, makeStyles, createStyles, Theme as AugmentedTheme } from '@material-ui/core';

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    LoaderHoder: {
        height: '100vh',
        paddingTop: 20,
    }
}))

export default function Loader() {
    const classes = useStyles();

    return(
        <Grid container justifyContent="center" className={classes.LoaderHoder}>
            <CircularProgress size={30} />
        </Grid>
    )
}
